import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import { takeEvery , takeLatest } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import * as Api from 'api';

/***************************** Selectors ************************************/
const getContacts = state => (state.contacts);
const getClient = state => (state.client);
/***************************** Subroutines ************************************/

function * fetchContacts(action) {
  const {payload} = action;
  if(!payload.clientId) {
    return console.warn('You must provide a clientId!');
  }
  try {
    const results = yield call(Api.fetchContacts, payload.clientId);
    yield put({ type : ActionTypes.FETCH_CONTACTS_SUCCESS, payload : results });
  }
  catch(ex) {
    console.error(ex);
    yield put({ type : ActionTypes.FETCH_CONTACTS_FAILED, payload : { message : ex.message } });
  }
}

function * createContact({payload}) {
  yield put(Actions.sendSocketEmit(payload , 'create-contact'));
}

function * deleteContact({payload}) {
  yield put(Actions.sendSocketEmit(payload, 'delete-contact'));
}

function * success() {
  const client = yield select(getClient);
  yield put(Actions.fetchContacts(client._id));
}
/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function * contactsWatcher() {
  yield * [
    takeLatest(ActionTypes.FETCH_CONTACTS, fetchContacts),
    takeLatest(ActionTypes.CREATE_CONTACT, createContact),
    takeLatest(ActionTypes.DELETE_CONTACT, deleteContact),
    takeLatest(ActionTypes.CREATE_CONTACT_SUCCESS, success),
    takeLatest(ActionTypes.DELETE_CONTACT_SUCCESS, success),
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/contacts.js